import orderEditDeliveryApi from './prod'; // dev
// import orderEditDeliveryApi from './prod'; // prod

export default orderEditDeliveryApi;
